import { PHOTO_MAX_BYTES } from '@ovo/shared'

// Фото профиля сжимаем прямо в браузере: квадрат по центру, 512×512, JPEG.
// На сервер уходит 30–80 КБ вместо мегабайтов с телефона; лишние данные снимка (EXIF, геометка) не уходят.

const SIDE = 512

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve(img)
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('Не удалось открыть фото — выберите файл JPG или PNG'))
    }
    img.src = url
  })
}

function toBlob(canvas: HTMLCanvasElement, quality: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Не удалось сжать фото'))), 'image/jpeg', quality)
  })
}

async function toBase64(blob: Blob): Promise<string> {
  const bytes = new Uint8Array(await blob.arrayBuffer())
  let bin = ''
  for (let i = 0; i < bytes.length; i += 0x8000) {
    bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000))
  }
  return btoa(bin)
}

export async function compressPhoto(file: File): Promise<{ mime: 'image/jpeg'; data: string }> {
  if (!file.type.startsWith('image/')) throw new Error('Это не фото — выберите картинку')
  const img = await loadImage(file)
  const side = Math.min(img.naturalWidth, img.naturalHeight)
  if (side < 64) throw new Error('Фото слишком маленькое — нужно хотя бы 64×64')
  const canvas = document.createElement('canvas')
  canvas.width = SIDE
  canvas.height = SIDE
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Браузер не умеет обрабатывать фото')
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, SIDE, SIDE)
  const sx = (img.naturalWidth - side) / 2
  const sy = (img.naturalHeight - side) / 2
  ctx.drawImage(img, sx, sy, side, side, 0, 0, SIDE, SIDE)
  for (const quality of [0.86, 0.75, 0.6]) {
    const blob = await toBlob(canvas, quality)
    if (blob.size <= PHOTO_MAX_BYTES) return { mime: 'image/jpeg', data: await toBase64(blob) }
  }
  throw new Error('Фото слишком большое — выберите другое')
}
